import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import withRouter from 'src/routes/withRouter';
import { Button, Radio, Tree } from 'antd';
import { mediaUrl as mediaUrlHandle } from 'kts-platform-frame/entry/configUtils';
import UICompanyUser from './UI.CompanyUser';
import UIDepartment from './UI.Department';
import UITeamworkUser from './UI.TeamworkUser';
// import Icon from 'src/display/components/Icon';
const { TreeNode, DirectoryTree } = Tree;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
 
    getRender = (key) => {
        if (this.modulesState.companyUserList.length > 0) {
            switch (key) {
                case 'teamworkUser':
                    return <UITeamworkUser />;
                case 'companyUser':
                    return <UICompanyUser />;
                case 'department':
                    return <UIDepartment />;
                default:
                    break;
            }
        }
        return null;

    }
    private tabsChange = (e) => {
        if(e.target.value === 'department'){
            ModulesAction.permissionQuery(1);
        }else{
            ModulesAction.permissionQuery(0);
        }
        this.modulesState.openTabVisible = e.target.value;
        this.setModulesState();
    }
    render() {
        return (
            <>
                <div className={css.tabs}>
                    <Radio.Group name="radiogroup" onChange={(e) => { this.tabsChange(e); }} defaultValue={this.modulesState.openTabVisible}>
                        <Radio className={css.mg} value={'teamworkUser'}>协作人员</Radio>
                        <Radio className={css.mg} value={'companyUser'}>公司成员</Radio>
                        <Radio className={css.mg} value={'department'}>部门管理</Radio>
                    </Radio.Group>
                </div>
                {this.getRender(this.modulesState.openTabVisible)}
            </>

            // <div className={css.setPowerContent}>
            //     {this.getRender(this.modulesState.openTabVisible)}
            // </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.SetPower/UI.Components.tsx